module.exports = {
        srcSet: __webpack_public_path__ + "static/media/paper-and-pen-664.c47fe7ca.webp"+" 664w",
        images: [{path: __webpack_public_path__ + "static/media/paper-and-pen-664.c47fe7ca.webp",width: 664,height: 664}],
        src: __webpack_public_path__ + "static/media/paper-and-pen-664.c47fe7ca.webp",
        toString: function(){return __webpack_public_path__ + "static/media/paper-and-pen-664.c47fe7ca.webp"},
        
        width: 664,
        height: 664
      }